// extracted by mini-css-extract-plugin
export default {"container":"index__container--t0mPK","loading-shimmer":"index__loading-shimmer--_kkuw","loadingShimmer":"index__loading-shimmer--_kkuw"};